(ns common.schema.entities.workspace.workspace-team
  (:require [common.schema.schema-utils :as su]))

(def schema
  (vec (concat (su/text-simple-field :workspace-team/name "Name" {})
               (su/multi-ref-field :workspace-team/members "Members" [:entity.type/account] {})
               (su/single-ref-field :workspace-team/workspace "Workspace" [:entity.type/kyc-process] {}))))
